import { render, staticRenderFns } from "./categories-v2.modal.vue?vue&type=template&id=62487f56&scoped=true"
import script from "./categories-v2.modal.vue?vue&type=script&lang=js"
export * from "./categories-v2.modal.vue?vue&type=script&lang=js"
import style0 from "./categories-v2.modal.vue?vue&type=style&index=0&id=62487f56&prod&lang=scss&scoped=true"
import style1 from "./categories-v2.modal.vue?vue&type=style&index=1&id=62487f56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62487f56",
  null
  
)

export default component.exports